"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const FiltersIcon = createIcon({
  displayName: "FiltersIcon",
  viewBox: "0 0 45 39",
  path: (
    <>
      <path
        d="M36.12,39c-2.49,0-4.59-.86-6.31-2.57-1.72-1.71-2.58-3.81-2.58-6.29s.86-4.58,2.58-6.29c1.72-1.71,3.82-2.57,6.31-2.57s4.59.86,6.31,2.57c1.72,1.71,2.58,3.81,2.58,6.29s-.86,4.58-2.58,6.29c-1.72,1.71-3.82,2.57-6.31,2.57ZM36.12,34.27c1.14,0,2.12-.4,2.93-1.21.81-.81,1.21-1.78,1.21-2.93s-.4-2.12-1.21-2.93c-.81-.81-1.79-1.21-2.93-1.21s-2.12.4-2.93,1.21c-.81.81-1.21,1.78-1.21,2.93s.4,2.12,1.21,2.93c.81.81,1.79,1.21,2.93,1.21ZM3.55,32.5v-4.73h18.95v4.73H3.55ZM8.88,17.73c-2.49,0-4.59-.86-6.31-2.57-1.72-1.71-2.58-3.81-2.58-6.29S.86,4.28,2.58,2.57C4.29.86,6.39,0,8.88,0s4.59.86,6.31,2.57c1.72,1.71,2.58,3.81,2.58,6.29s-.86,4.58-2.58,6.29c-1.72,1.71-3.82,2.57-6.31,2.57ZM8.88,13c1.14,0,2.12-.4,2.93-1.21.81-.81,1.21-1.78,1.21-2.92s-.4-2.12-1.21-2.92c-.81-.81-1.79-1.21-2.93-1.21s-2.12.4-2.93,1.21c-.81.81-1.21,1.78-1.21,2.92s.4,2.12,1.21,2.92c.81.81,1.79,1.21,2.93,1.21ZM22.5,11.23v-4.73h18.95v4.73h-18.95Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default FiltersIcon;
